import * as React from "react";

export class SportHeader extends React.PureComponent<{ label: string }, {}> {
    render() {
        return (
            <h3 className="rj-league-list__sport-header" data-uat="h3-league-list-sport-header">

                <span className="rj-league-list__header-title" data-uat="span-league-list-sport-header-title">{this.props.label}</span>
                {this.props.children}
            </h3>
        )
    }
}